import { useFeatureFlagValue } from '@experiences/feature-flags';
import type { PropsWithChildren } from 'react';
import React from 'react';

import InvalidUrl from '../../component/authentication/InvalidUrl';

interface CheckGuardComponentProps {
    tester?: ((...args: any[]) => boolean) | boolean;
    flag?: string;
    /**
     * Rendered instead of `InvalidUrl` when the check denies. Permission gates should pass a 403:
     * the address is valid, it is the caller who lacks the permission.
     */
    deny?: JSX.Element;
    /**
     * True while the answer is not yet known — an unresolved PDP call, for example. Renders nothing
     * rather than showing a deny state that would be replaced a tick later.
     */
    pending?: boolean;
}

export const CheckGuardComponent: React.FC<PropsWithChildren<CheckGuardComponentProps>> = ({
    tester, flag, deny, pending, children,
}) => {
    const flagValue = useFeatureFlagValue(flag ?? '');

    if (flagValue) {
        return children;
    }

    if (pending) {
        return null;
    }

    const allowed = typeof tester === 'function' ? tester() : tester;

    return allowed ? children : (deny ?? <InvalidUrl />);
};
